import styled, { css } from 'styled-components';
import { THEME } from '../../../themes';
import { Body1Font, ButtonFont, HeadlineFont } from '../../../themes/fonts';
import Dialog from '../base-dialog/base-dialog.component';
import BaseButton from '../../Common/Buttons/perfect-base-button/perfect-base-button.component';
import { fadeInAnimation } from '../../../animations';
import { ELEMENTS_DURATION } from '../../../consts/durations';
import { hexToRgbA } from '../../../utils/colors';

const Container = css`
  display: flex;
  gap: ${THEME.SPACING.MEDIUM};
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

export const HeaderContainer = styled(Dialog.Header)`
  ${Container};
  padding: ${THEME.SPACING.MEDIUM} ${THEME.SPACING.LOOSE};
`;

export const BodyContainer = styled(Dialog.Body)`
  ${Container};
  padding: ${THEME.SPACING.MEDIUM} ${THEME.SPACING.LOOSE};
  align-items: start;
`;

export const FooterContainer = styled(Dialog.Footer)`
  ${Container};
  padding: 0 ${THEME.SPACING.LOOSE};
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${THEME.SPACING.LOOSE};
  margin-bottom: ${THEME.SPACING.BASE};
`;

export const DialogHeaderTitle = styled.div`
  ${ButtonFont};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const SaveButton = styled(BaseButton)`
  background-color: ${THEME.COLORS.ACCENT};
`;

export const EmptyStateMessage = styled.div`
  ${HeadlineFont};
  font-weight: 300;
  opacity: ${THEME.OPACITY.LOW};
  text-align: center;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const SuggestionListContainer = styled.div`
  display: inline-flex;
  gap: ${THEME.SPACING.TINY};
  flex-wrap: wrap;
  justify-content: center;

  animation: ${fadeInAnimation({
    animationDuration: ELEMENTS_DURATION.JOB_DESCRIPTION_TITLE_DURATION,
    animationDelay: 0,
  })
}
`;

export const SomethingElseDescription = styled.div`
  ${Body1Font};
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
  line-height: 24px;
  white-space: break-spaces;
`;

export const InfoButton = styled.a`
  color: ${THEME.COLORS.ACCENT};
  text-decoration: underline;
  cursor: pointer;
`;

export const FooterInfoText = styled.div`
  ${Body1Font};
  color: ${hexToRgbA(THEME.COLORS.CONTENT_A, THEME.OPACITY.MED)};
`;
